export const pageRoute = {
  Forbidden: '/403',
  Dashboard: '/',
  Disabled: '/disabled',
  HealthCheck: '/health-check',
  NotFound: '/not-found',
  Notifications: '/notifications',
  OauthCallback: '/oauth-callback',
  Share: '/share',
  Subaccounts: '/subaccounts',
  AffiliateDashboard: '/affiliate-dashboard',
  AgencyUsers: '/agency-center/white-label-users',
  AgencySettings: '/agency-center/white-label-settings',
  AgencyPricePlans: '/agency-center/price-plans',
  Contacts: '/contacts',
  AssistantContacts: '/assistant/contacts',
  ContactsBin: '/contacts/bin',
  ContactsCreate: '/contacts/create',
  ContactsImport: '/contacts/import',
  Tags: '/tags',
  CrmPipeline: '/crm-pipeline',
  Calendar: '/calendar',
  CalendarAvailability: '/calendar/availability',
  CalendarBookings: '/calendar/bookings',
  CalendarCreate: '/calendar/create',
  Websites: '/websites',
  Funnels: '/funnels',
  Stores: '/stores',
  Blogs: '/blogs',
  Newsletters: '/newsletters',
  Campaigns: '/campaigns',
  EmailStatistics: '/email-statistics',
  SmsTemplates: '/sms/templates',
  SmsStatistics: '/sms/statistics',
  SmsTemplateDetailsBase: '/sms/templates',
  AutomationRules: '/automation-rules',
  AutomationRulesCreate: '/automation-rules/create',
  Workflows: '/workflows',
  Products: '/products',
  ProductsCreate: '/products/create',
  Coupons: '/coupons',
  Courses: '/courses',
  CoursesAssignments: '/courses/assignments',
  CoursesBundles: '/courses/bundles',
  CoursesStudents: '/courses/students',
  Communities: '/communities',
  Files: '/files',
  Orders: '/orders',
  Transactions: '/payment/transactions',
  Subscriptions: '/payment/subscriptions',
  AffiliateInvoices: '/payment/affiliate-invoices',
  AffiliateProgram: '/affiliate-program',
  AdminUsers: '/management/users',
  AdminEmailTemplates: '/management/email-templates',
  AdminPageTemplates: '/management/page-templates',
  AdminBlogTemplates: '/management/blog-templates',
  AdminWebsiteTemplates: '/management/website-templates',
  AdminFunnelTemplates: '/management/funnel-templates',
  AdminCustomers: '/management/user-customer-list',
  AdminEmailStats: '/management/emails-delivery-statistics',
  AdminEmailPendingMailing: '/management/emails-delivery-statistics/email-pending-mailing',
  AdminUserPlans: '/management/user-plans',
  AdminDomainsBlocked: '/management/blocked-mailbox-provider',
  AdminDomainsWhitelist: '/management/white-list-mailbox',
  AdminSuspiciousPageKeywords: '/management/suspicious-page-content-keyword',
  AdminSuspiciousEmailKeywords: '/management/suspicious-email-keyword',
  AdminSuspiciousEmailAddress: '/management/suspicious-email-address',
  AdminStatistics: '/management/statistics',
  ProfileUserSettings: '/profile/user-settings',
  ProfileAccountSettings: '/profile/account-settings',
  ProfileUserPlan: '/profile/user-plan',
  ProfilePaymentGateways: '/profile/payment-gateways',
  ProfilePaymentGatewaysPaypal: '/profile/payment-gateways/paypal',
  ProfileManageSubscriptions: '/profile/manage-subscriptions',
  ProfileManageSubscriptionInvoices: '/profile/manage-subscriptions/[subscriptionId]/invoices',
  ProfileMailingSettings: '/profile/mailing-settings',
  ProfileCourseSettings: '/profile/course-settings',
  ProfilePaymentSettings: '/profile/payment-settings',
  ProfileSalesFunnelsSettings: '/profile/sales-funnels-settings',
  ProfileShippingSettings: '/profile/shipping-settings',
  ProfileAffiliateProgramSettings: '/profile/affiliate-program-settings',
  ProfileCustomDomainsSettings: '/profile/custom-domains-settings',
  ProfilePublicApiSettings: '/profile/public-api-settings',
  ProfileWebhookSettings: '/profile/webhook-settings',
  ProfileIntegrations: '/profile/integrations',
  ProfileAffiliateSettings: '/profile/affiliate-settings',
  ProfileNotificationSettings: '/profile/notification-settings',
  ProfileWorkspaceMembers: '/profile/workspace-members',
  ProfileChangePassword: '/profile/change-password',
  AffiliateProgramDetails: '/affiliate-program/[affiliateId]',
  AgencyPricePlanDetails: '/agency-center/price-plans/[languageId]/[userPlanId]',
  AutomationRuleDetails: '/automation-rules/[automationRuleId]',
  BlogDetails: '/blogs/[blogId]',
  CalendarEventDetails: '/calendar/[eventId]',
  CampaignDetails: '/campaigns/[campaignId]',
  CampaignStepEdit: '/campaigns/[campaignId]/campaign-step/[campaignStepId]/edit',
  ConfirmCustomerRole: '/confirm-customer-role/[token]',
  ContactDetails: '/contacts/[contactId]',
  ContactEmailHistory: '/contacts/[contactId]/email-history',
  CouponDetails: '/coupons/[couponId]',
  CourseBundleDetails: '/courses/bundles/[courseBundleId]',
  CourseCurriculum: '/courses/[courseId]/curriculum',
  CourseCurriculumAssignmentCreate: '/courses/[courseId]/curriculum/[lectureId]/assignment/create',
  CourseCurriculumAssignmentEdit: '/courses/[courseId]/curriculum/[lectureId]/assignment/edit',
  CourseCurriculumEmail: '/courses/[courseId]/curriculum/[lectureId]/email',
  CourseDetails: '/courses/[courseId]',
  CourseLightCurriculum: '/courses/light-course/[courseId]/curriculum',
  CourseLightCurriculumLecture: '/courses/light-course/[courseId]/curriculum/[lectureId]',
  CourseLightSettings: '/courses/light-course/[courseId]/settings',
  CourseQuizDetails: '/courses/module/quiz/[quizId]',
  CourseQuizResults: '/courses/module/quiz/[quizId]/results',
  CourseQuizStudentResults: '/courses/module/quiz/[quizId]/student/[studentId]/results',
  CoursesStudentDetails: '/courses/students/[studentId]',
  CrmPipelineDetails: '/crm-pipeline/[pipelineId]',
  FunnelDetails: '/funnels/[funnelId]',
  ManagementEmailPendingMailingDetails:
    '/management/emails-delivery-statistics/email-pending-mailing/[emailId]',
  ManagementEmailStatsMailingDetails: '/management/emails-delivery-statistics/mailing/[mailingId]',
  ManagementEmailStatsUserDetails: '/management/emails-delivery-statistics/[userId]',
  MailingEmailAddressConfirm: '/mailing/email-address/confirm/[token]',
  MailingSplitTestStatistics: '/mailing/split-test/[newsletterId]/statistics',
  MailingStatistics: '/mailing/[mailingId]/statistics',
  MailingStatisticsLink: '/mailing/[mailingId]/statistics/[mailingLinkId]',
  NewsletterEdit: '/newsletters/[newsletterId]/edit',
  ProductDetails: '/products/[productId]',
  ProfileWebhookSettingsDetails: '/profile/webhook-settings/[id]',
  SmsStatisticsDetails: '/sms/statistics/[smsTemplateId]',
  SmsTemplateDetails: '/sms/templates/[templateId]',
  StoreDetails: '/stores/[storeId]',
  WorkflowEmailDetails: '/workflows/[workflowId]/emails/[emailId]',
  WorkflowEmailWithRecipientDetails: '/workflows/[workflowId]/emails-with-recipient/[emailId]',
  WorkflowSmsDetails: '/workflows/[workflowId]/sms/[smsId]',
  Helpdesk: '/helpdesk',
} as const

export type PageRouteValue = (typeof pageRoute)[keyof typeof pageRoute]
